import { render, staticRenderFns } from "./tiktok-speed.vue?vue&type=template&id=f3ef5cfa&scoped=true&"
import script from "./tiktok-speed.vue?vue&type=script&lang=js&"
export * from "./tiktok-speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ef5cfa",
  null
  
)

export default component.exports